module.exports = __webpack_public_path__ + "static/media/sharing.6445f7ae.svg";